goog.provide("shadow.js.shim.module$dayjs$locale$ms");
goog.provide("module$shadow_js_shim_module$dayjs$locale$ms");
shadow.js.shim.module$dayjs$locale$ms = shadow.js.nativeProvides["dayjs/locale/ms"] = require("dayjs/locale/ms");
module$shadow_js_shim_module$dayjs$locale$ms.default = shadow.js.shim.module$dayjs$locale$ms;
